const provider = require('./src/provider');

exports.wrapPageElement = provider.wrapPageElement;
